class NgMimeTypeDirective {

    constructor() {
        this.restrict = 'A';
        this.require = 'ngModel';
        this.scope = false;
    }

    link(scope, element, attrs, ngModel) {
        const types = attrs.ngMimeType.split(',').map((s) => s.trim());
        if (window.FileReader) {
            ngModel.$validators.mimeType = (value) => {
                if(value instanceof File) {
                    return types.indexOf(value.type) !== -1;
                } else {
                    return null;
                }
            };
        }
    }

    static factory() {
        return new NgMimeTypeDirective();
    }
}

// Explicit DI annotation for factory used in angular.directive registration
NgMimeTypeDirective.factory.$inject = [];

export default NgMimeTypeDirective.factory;
